<div class="dialog">
    <div class="dialog-header">
        {{isCancel ? '撤回' : '退回' }}{{fileOpts.length > 0 ? '会签单' : ''}}
    </div>
    <div class="dialog-body">
        <div class="grid">
            <div class="row validate">
                <div class="column background-page text-right" [style.width]="90 + 'px'">
                    <span class="color-danger">*</span> {{isCancel ? '撤回' : '退回' }}节点
                </div>
                <div class="column" [style.width]="410 + 'px'">
                    <select [(ngModel)]="selectFlow">
                        <option value="" [disabled]="true">请选择{{isCancel ? '撤回' : '退回' }}节点</option>
                        <option *ngFor="let flow of flowOpts" [value]="flow.value">{{ flow.label }}</option>
                    </select>
                </div>
            </div>
            <div class="row validate">
                <div class="column background-page text-right" [style.width]="90 + 'px'">
                    <span class="color-danger">*</span> {{isCancel ? '撤回' : '退回' }}理由
                </div>
                <div class="column" [style.width]="410 + 'px'">
                    <input type="text" placeholder="输入{{isCancel ? '撤回' : '退回' }}理由" [(ngModel)]="record.rejectReason">
                </div>
            </div>
        </div>
        <br>
        <div class="grid" *ngIf="fileOpts.length > 0 && flowOpts.length > 0 && selectFlow === flowOpts[0].value">
            <div class="row">
                <div class="column background-page" [style.width]="500 + 'px'">
                    指定要同时{{isCancel ? '撤回' : '退回' }}的主文件
                </div>
            </div>
            <div class="row" *ngFor="let item of fileOpts" (click)="choose(item.value!)">
                <div class="column" [style.width]="40 + 'px'">
                    <span class="color-primary" *ngIf="selected.includes(item.value!)" nz-icon nzType="check-square"
                        nzTheme="outline">
                    </span>
                    <span class="color-primary" *ngIf="!selected.includes(item.value!)" nz-icon nzType="border"
                        nzTheme="outline">
                    </span>
                </div>
                <div class="column {{selected.includes(item.value!) ? 'color-primary' : '' }}"
                    [style.width]="460 + 'px'">
                    <format-data [contentStr]="item.label"></format-data>
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <button nz-button nzType="default" (click)="cancel()">取消</button>
        <button nz-button nzType="primary" (click)="confirm()" [disabled]="!canConfirm">确认</button>
    </div>
</div>